import React from 'react';

const FundingMatchClientSelector = ({
  clients,
  selectedClientId,
  onSelect,
  loading,
  requiresAgencySelection,
}) => {
  if (requiresAgencySelection) {
    return (
      <p className="text-sm text-[var(--fg-muted)]">
        Select an agency in the header to load funding clients.
      </p>
    );
  }

  if (loading) {
    return <p className="text-sm text-[var(--fg-muted)]">Loading funding clients...</p>;
  }

  if (!clients.length) {
    return <p className="text-sm text-[var(--fg-muted)]">No funding clients yet. Add a client to run lender matching.</p>;
  }

  return (
    <div className="space-y-2">
      {clients.map((client) => {
        const active = client.id === selectedClientId;
        return (
          <button
            key={client.id}
            type="button"
            onClick={() => onSelect(client.id)}
            className={`w-full rounded-xl border px-3 py-3 text-left transition ${
              active
                ? 'border-[var(--fg-accent)] bg-[var(--fg-accent-soft)]'
                : 'border-[var(--fg-line)] bg-white hover:border-[var(--fg-accent)]/40 dark:bg-slate-950/20'
            }`}
          >
            <div className="font-medium text-[var(--fg-text)]">{client.name}</div>
            <div className="mt-1 text-xs text-[var(--fg-muted)]">
              {client.readinessTier || 'Unscored'} · {client.documentStatus || 'Missing docs'}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default FundingMatchClientSelector;
